// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2582":"99aadabf","4002":"f3fda6d2"}[chunkId] + ".css";
};